import { z } from 'zod';
import { transformAndFilterValidItems } from './transformUtils';

/**
 * Transforms and filters valid edges as returned by Pimcore GraphQL API.
 *
 * @param nodeSchema The schema to validate the nodes.
 * @param edges The edges to transform and filter.
 * @returns The transformed and filtered nodes.
 */
export function transformAndFilterValidEdges<T extends z.ZodTypeAny>(
    nodeSchema: T,
    edges: Array<{ node?: unknown | null } | null> | null | undefined
): { node: z.infer<T> }[] {
    // Extract nodes from edges and validate them using the generic item transformer
    const nodes = edges?.map((edge) => edge?.node) ?? [];
    return transformAndFilterValidItems(nodeSchema, nodes).map((node) => ({ node: node }));
}
